// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuBtn_container__G2bRQ","menu":"MenuBtn_menu__2gJaD","close":"MenuBtn_close__lMDxq","open":"MenuBtn_open__wSonc","wrapper":"MenuBtn_wrapper__5eRVW"};